import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../../common/utils/styles/css/styles';

export default function Pending() {
  const { t } = useTranslation();
  return (
    <div css={styles.tac}>
      <img alt="" src="/static/images/register/img-verification-in-progress.svg" />
      <h1 css={styles.mtm}>
        {t('signin.message.registration.pending.title', 'Registration pending verification')}
      </h1>
      <p>
        {t(
          'signin.message.registration.pending.subtitle',
          "We're currently verifying your registration data. We'll send you an email once we're done."
        )}
      </p>
    </div>
  );
}
